const generateRandomString = (length) =>  {
    // const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    // let result = '';
    // const charactersLength = characters.length;
    // for (let i = 0; i < length; i++) {
    //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
    // }
    // console.log("result", result);
    const currentTimeMillis = Date.now();
    return `${currentTimeMillis}tuv`;
}

const validateUser=(username)=> {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(`${username}@test.cte`);
  }

export { generateRandomString, validateUser };